import React from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  RedAsterix,
  Grid,
  VStack,
  ModalBody,
  Box,
  Divider,
  DateInputNoYearV2,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import { PackageFormValues } from '../../../../types/Form';
import AdvisoryReportTitleWithDescription from '../../../shared/AdvisoryReportTitleWithDescription';
import { Change } from '../../../../../../../../../types/Form';
import AddInsuranceModalInsuranceFormPremiumFields from '../../shared/modal/insurance-form/AddInsuranceModalInsuranceFormPremiumFields';

const PackageEditModalBody: React.FC = () => {
  const { t } = useTranslation();
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<PackageFormValues>();

  return (
    <ModalBody
      as={VStack}
      align="stretch"
      spacing="4"
      divider={<Divider borderColor="gray.50" />}
    >
      <AdvisoryReportTitleWithDescription
        title={t(`ADVISORY-REPORTS_CREATION-FLOW_PACKAGE_MODAL_DETAIL-TITLE`)}
        description={t(
          `ADVISORY-REPORTS_CREATION-FLOW_PACKAGE_MODAL_DESCRIPTION`,
        )}
      />
      <Grid
        templateColumns={{ base: '1fr', tablet: 'repeat(2, 1fr)' }}
        gridGap="4"
      >
        <FormControl isInvalid={!!errors.name}>
          <FormLabel>
            {t(`ADVISORY-REPORTS_PACKAGE_MODAL_LABEL_NAME`)} <RedAsterix />
          </FormLabel>
          <Input {...register('name')} />
          {errors.name?.message && (
            <FormErrorMessage>{t(errors.name.message)}</FormErrorMessage>
          )}
        </FormControl>
        {/* Package nr */}
        <FormControl isInvalid={!!errors.package_nr}>
          <FormLabel>
            {t(`ADVISORY-REPORTS_CURRENT-INSURANCE_OVERVIEW_PACKAGE-NR`)}{' '}
            <RedAsterix />
          </FormLabel>
          <Input {...register('package_nr')} />
          {errors.package_nr?.message && (
            <FormErrorMessage>{t(errors.package_nr.message)}</FormErrorMessage>
          )}
        </FormControl>
        {/* Insurance company */}
        <FormControl isInvalid={!!errors.insurance_company}>
          <FormLabel>
            {t(`CARRIER`)} <RedAsterix />
          </FormLabel>
          <Input {...register('insurance_company')} />
          {errors.insurance_company?.message && (
            <FormErrorMessage>
              {t(errors.insurance_company.message)}
            </FormErrorMessage>
          )}
        </FormControl>
        {/* Expiration date */}
        <Controller
          name="due_date"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <FormControl isInvalid={!!error}>
              <FormLabel>
                {t(
                  'ADVISORY-REPORTS_CURRENT-INSURANCE_MODAL_DETAIL_EXPIRATION-DATE',
                )}
              </FormLabel>
              <DateInputNoYearV2
                onChange={({ value }: Change) => {
                  onChange(value);
                }}
                initialValue={value}
              />
              {error?.message && (
                <FormErrorMessage>{t(error.message)}</FormErrorMessage>
              )}
            </FormControl>
          )}
        />
        <Box gridColumn="span 2">
          <AddInsuranceModalInsuranceFormPremiumFields />
        </Box>
      </Grid>
    </ModalBody>
  );
};

export default PackageEditModalBody;
